import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IStatus, StatusPicker } from '@dfl/mui-react-common';
import { BUSINESS_ACCOUNT_REQUEST_STATUS_MAP } from '../../constants/business-account-request.status';
import { BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM } from '../../interfaces';

type BusinessAccountRequestStatusCellProps = {
  status: BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM;
};

const BusinessAccountRequestStatusCell = ({ status }: BusinessAccountRequestStatusCellProps) => {
  const { t } = useTranslation('businessAccountRequest');
  const value = BUSINESS_ACCOUNT_REQUEST_STATUS_MAP.get(status);

  if (!value) return null;

  const translatedValue: IStatus = { ...value, title: t(`status.${value.title}`) };

  return (
    <StatusPicker
      readOnly
      name='status'
      size='small'
      value={translatedValue}
      onChange={() => {}}
    />
  );
};

export default memo(BusinessAccountRequestStatusCell);
